(function () {
  if (customElements.get('op-entrega')) return;

  var TZ = 'America/Santiago';
  var STORE_KEY = 'op-envios:zone';
  var rulesPromises = {};

  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
  }

  function loadRules(url) {
    if (!rulesPromises[url]) {
      rulesPromises[url] = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .catch(function (e) {
          delete rulesPromises[url];
          throw e;
        });
    }
    return rulesPromises[url];
  }

  function readSaved() {
    try {
      return JSON.parse(localStorage.getItem(STORE_KEY)) || null;
    } catch (e) {
      return null;
    }
  }

  function writeSaved(zone) {
    try {
      localStorage.setItem(STORE_KEY, JSON.stringify(zone));
    } catch (e) {}
  }

  function santiagoNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ,
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      hourCycle: 'h23'
    }).formatToParts(new Date());
    var v = {};
    parts.forEach(function (p) {
      v[p.type] = Number(p.value);
    });
    return { date: new Date(Date.UTC(v.year, v.month - 1, v.day)), hour: v.hour };
  }

  function isBusinessDay(d) {
    var w = d.getUTCDay();
    return w !== 0 && w !== 6;
  }

  function addDays(d, n) {
    return new Date(d.getTime() + n * 86400000);
  }

  function nextBusinessDay(d) {
    var out = addDays(d, 1);
    while (!isBusinessDay(out)) out = addDays(out, 1);
    return out;
  }

  function addBusinessDays(d, n) {
    var out = d;
    for (var i = 0; i < n; i++) out = nextBusinessDay(out);
    return out;
  }

  function startDay(cutoff) {
    var now = santiagoNow();
    var day = now.date;
    var late = cutoff > 0 && now.hour >= cutoff;
    if (!isBusinessDay(day) || late) day = nextBusinessDay(day);
    return day;
  }

  function fmt(d, opts) {
    return new Intl.DateTimeFormat('es-CL', Object.assign({ timeZone: 'UTC' }, opts)).format(d).replace(/\./g, '');
  }

  function dayLabel(d) {
    return fmt(d, { weekday: 'short' }) + ' ' + fmt(d, { day: 'numeric' });
  }

  function monthLabel(d) {
    return fmt(d, { month: 'short' });
  }

  function findRule(rules, region, city) {
    var best = null;
    var rank = 0;
    var n = norm(city);
    rules.forEach(function (r) {
      var score = 0;
      if (r.region === region && norm(r.comuna) === n && n) score = 3;
      else if (r.region === region && r.comuna === '*') score = 2;
      else if (r.region === '*') score = 1;
      if (score > rank) {
        rank = score;
        best = r;
      }
    });
    return best;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  }

  var uid = 0;

  class OpEntrega extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.texts = {};
      try {
        this.texts = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch (e) {}
      this.cutoff = Number(this.dataset.cutoff) || 0;
      this.regionSel = this.querySelector('[data-ent-region]');
      this.citySel = this.querySelector('[data-ent-city]');
      this.result = this.querySelector('[data-ent-result]');
      this.zoneBtn = this.querySelector('[data-ent-zone]');
      this.zoneLabel = this.querySelector('[data-ent-zone-label]');
      this.picker = this.querySelector('[data-ent-picker]');
      this.note = this.querySelector('[data-ent-note]');
      this.zone = null;
      this.geo = [];
      this.rules = [];
      var self = this;
      this.regionSel.addEventListener('change', function () {
        self.fillCities(self.regionSel.value, '');
        self.zone = null;
        self.render();
      });
      this.citySel.addEventListener('change', function () {
        if (!self.citySel.value) return;
        self.zone = { region: self.regionSel.value, city: self.citySel.value, source: 'manual' };
        writeSaved({ region: self.zone.region, city: self.zone.city });
        self.togglePicker(false);
        self.render();
        self.zoneBtn.focus();
      });
      this.zoneBtn.addEventListener('click', function () {
        self.togglePicker(self.picker.hidden);
      });
      loadRules(this.dataset.rulesUrl)
        .then(function (data) {
          self.geo = data.geo || [];
          self.rules = data.rules || [];
          self.fillRegions();
          self.restore();
        })
        .catch(function () {
          self.showMessage(self.texts.error);
          self.classList.add('op-ent--error');
        });
    }

    fillRegions() {
      var self = this;
      this.regionSel.replaceChildren(new Option(this.texts.regionPlaceholder, ''));
      this.geo.forEach(function (r) {
        self.regionSel.add(new Option(r.name, r.code));
      });
      this.regionSel.disabled = false;
    }

    fillCities(code, city) {
      var region = this.geo.filter(function (r) {
        return r.code === code;
      })[0];
      this.citySel.replaceChildren(new Option(this.texts.cityPlaceholder, ''));
      this.citySel.disabled = !region;
      if (!region) return;
      var self = this;
      region.communes.forEach(function (c) {
        self.citySel.add(new Option(c, c));
      });
      if (city) this.citySel.value = city;
    }

    communeName(code, city) {
      var region = this.geo.filter(function (r) {
        return r.code === code;
      })[0];
      var n = norm(city);
      return (
        (region &&
          region.communes.filter(function (c) {
            return norm(c) === n;
          })[0]) ||
        ''
      );
    }

    regionFor(province, city) {
      var self = this;
      var p = norm(province);
      var byProvince = this.geo.filter(function (r) {
        return norm(r.code) === p || (p && (norm(r.name).indexOf(p) !== -1 || p.indexOf(norm(r.name)) !== -1));
      });
      var pool = byProvince.length ? byProvince : this.geo;
      var hit = pool.filter(function (r) {
        return self.communeName(r.code, city);
      })[0];
      return hit ? hit.code : '';
    }

    restore() {
      var pick = null;
      var account = {
        province: this.dataset.province || '',
        city: this.dataset.city || ''
      };
      if (account.city) {
        var code = this.regionFor(account.province, account.city);
        if (code) pick = { region: code, city: this.communeName(code, account.city), source: 'account' };
      }
      if (!pick) {
        var saved = readSaved();
        if (saved && this.communeName(saved.region, saved.city)) {
          pick = { region: saved.region, city: this.communeName(saved.region, saved.city), source: 'manual' };
        }
      }
      if (pick) {
        this.zone = pick;
        this.regionSel.value = pick.region;
        this.fillCities(pick.region, pick.city);
      }
      this.togglePicker(!pick);
      this.render();
    }

    togglePicker(open) {
      this.picker.hidden = !open;
      this.zoneBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      this.classList.toggle('op-ent--picking', open);
      if (open && !this.zone) this.zoneBtn.hidden = true;
      else this.zoneBtn.hidden = false;
      if (open && this.zone) this.regionSel.focus();
    }

    showMessage(text) {
      this.result.replaceChildren(el('p', 'op-ent__msg', text));
    }

    render() {
      var t = this.texts;
      this.classList.remove('op-ent--ready');
      if (!this.zone) {
        this.zoneLabel.textContent = '';
        this.note.hidden = true;
        this.showMessage(t.choose);
        return;
      }
      this.zoneLabel.textContent = this.zone.city;
      this.note.hidden = this.zone.source !== 'account';
      var rule = findRule(this.rules, this.zone.region, this.zone.city);
      if (!rule) {
        this.showMessage(t.none);
        return;
      }
      var start = startDay(this.cutoff);
      var from = addBusinessDays(start, rule.min);
      var to = addBusinessDays(start, rule.max);
      var same = from.getTime() === to.getTime();
      var sameMonth = monthLabel(from) === monthLabel(to);
      var fromText = dayLabel(from) + (same || sameMonth ? '' : ' ' + monthLabel(from));
      var toText = dayLabel(to) + ' ' + monthLabel(to);
      var template = same ? t.single : t.range;
      var values = { '{desde}': fromText, '{hasta}': toText, '{fecha}': toText };
      var days =
        rule.min === rule.max
          ? rule.min + (rule.min === 1 ? ' ' + t.daySingular : ' ' + t.dayPlural)
          : rule.min + '–' + rule.max + ' ' + t.dayPlural;

      var head = el('p', 'op-ent__headline');
      template.split(/(\{desde\}|\{hasta\}|\{fecha\})/).forEach(function (p) {
        if (values[p]) head.append(el('strong', '', values[p]));
        else if (p) head.append(document.createTextNode(p));
      });
      var chip = el('span', 'op-ent__chip', days);

      var track = el('div', 'op-ent__track');
      track.setAttribute('aria-hidden', 'true');
      var a = el('div', 'op-ent__stop');
      a.append(el('span', 'op-ent__dot'), el('span', 'op-ent__stop-label', t.stepOrder), el('span', 'op-ent__stop-date', dayLabel(santiagoNow().date)));
      var line = el('div', 'op-ent__route');
      line.append(el('span', 'op-ent__truck'));
      var b = el('div', 'op-ent__stop op-ent__stop--end');
      b.append(el('span', 'op-ent__dot op-ent__dot--end'), el('span', 'op-ent__stop-label', t.stepArrive), el('span', 'op-ent__stop-date', same ? dayLabel(to) : dayLabel(from) + ' – ' + dayLabel(to)));
      track.append(a, line, b);

      this.result.replaceChildren(head, chip, track);
      var self = this;
      requestAnimationFrame(function () {
        self.classList.add('op-ent--ready');
      });
    }
  }

  customElements.define('op-entrega', OpEntrega);
})();
